import React, { useState } from 'react';
import { BsClipboard, BsCheck } from 'react-icons/bs';

export default function CopyButton({ value, label }) {
  const [copied, setCopied] = useState(false);
  if (!value) return null;
  return <button type="button" className="btn btn-sm btn-link p-0 ms-1" title={copied ? 'Copiado' : `Copiar ${label}`} aria-label={copied ? `${label} copiado` : `Copiar ${label}`} onClick={async (event) => {
    event.stopPropagation();
    try { await navigator.clipboard.writeText(String(value)); setCopied(true); }
    catch (_err) { window.alert('No se pudo copiar. Selecciona el texto para copiarlo manualmente.'); }
  }}>{copied ? <BsCheck aria-hidden="true" /> : <BsClipboard aria-hidden="true" />}</button>;
}
